import Vue from "vue";
import LazyLoad from "vanilla-lazyload/dist/lazyload";
import "fg-loadcss/dist/cssrelpreload";
import objectFitImages from "object-fit-images";

/**
 * A mixin that we're going to include in every VueApp
 * instance. Used to provide common functionality to all pages.
 */
export default Vue.extend( {
  data: () => ( {
    showOverlay: false,
    showMegaMenu: false,
    preventHidingOverlay: false,
    preventHidingMegaMenu: false,
    menuItemsState: {},
  } ),
  watch: {
    showOverlay ( val ) {
      if ( val ) {
        this.preventHidingOverlay = true;
      }
    },
    preventHidingOverlay () {
      window.setTimeout( () => {
        this.preventHidingOverlay = false;
      }, 300 );
    },
    showMegaMenu ( val ) {
      if ( val ) {
        this.preventHidingMegaMenu = true;
      }
    },
    preventHidingMegaMenu () {
      window.setTimeout( () => {
        this.preventHidingMegaMenu = false;
      }, 300 );
    },
  },
  mounted () {
    new LazyLoad( {
      elements_selector: "img, .lazy",
    } );

    objectFitImages();
  },
  methods: {
    toggleMenuItem ( alias ) {
      this.$set( this.menuItemsState, alias, !this.menuItemsState[alias] );
    },
    getMenuItemState ( alias ) {
      return this.menuItemsState[alias];
    },
    getMenuToggleClass ( alias ) {
      let result = {};

      if ( this.getMenuItemState( alias ) ) {
        result = {
          "main-navigation__accordion-toggle--open": true,
        };
      }

      return result;
    },
    getIconRotation ( alias ) {
      let result = null;

      if ( this.getMenuItemState( alias ) ) {
        result = 180;
      }

      return result;
    },
    closeOverlay () {
      if ( !this.preventHidingOverlay ) {
        this.showOverlay = false;
      }
    },
    closeMegaMenu () {
      if ( !this.preventHidingMegaMenu ) {
        this.showMegaMenu = false;
      }
    },
  },
} );
